var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_vm._t("default",[_c('div',{staticClass:"header-wrap"},[_c('router-link',{staticClass:"home-link",attrs:{"to":"/"}},[_c('h1',[_vm._v("Book of Remembrance")])])],1)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }